






























import Vue from "vue";
import Error from "@/components/basic/Error.vue";
// @ts-ignore
import VueMask from "v-mask";
import { ResponseError } from "@/types";
import { DELETE_ERROR } from "@/constants/mutation-types";
import { mapState } from "vuex";

Vue.use(VueMask);

export default Vue.extend({
  name: "Field",
  props: {
    type: String,
    name: String,
    value: String,
    maxLength: Number,
    placeholder: String,
    disabled: {
      type: [String, Boolean],
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    handlesError: {
      type: Boolean,
      default: true,
    },
    isValidated: {
      type: Boolean,
      default: true,
    },
    handlesDataPreload: {
      type: Boolean,
      default: true,
    },
    suggestions: {
      type: Boolean,
      default: false,
    },
    disablePaste: {
      type: Boolean,
      default: false,
    },
    onlyNumbers: {
      type: Boolean,
      default: false,
    },
    standardFilter: {
      type: Boolean,
      default: false,
    },
    streetFilter: {
      type: Boolean,
      default: false,
    },
    allowAllCharacters: {
      type: Boolean,
      default: false,
    },
    isNumeric: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: null,
      isValid: false,
      model: this.value,
      isDataLoading: false,
      validateCity: true,
      validateStreet: true,
      validateBuildingNumber: true,
      validateApartmentNumber: true,
      standardCharactersFilter: /^[\p{L}/,.'-:()’\d\s-]+$/u,
      streetCharactersFilter: /^[\p{L}/,.':()"&*’\d\s-]+$/u,
      numbersFilter: /^\d+$/,
    };
  },
  mounted() {
    if (this.handlesDataPreload) {
      this.loadData();
    }

    if (this.model && this.model.length && this.name !== "email") {
      this.validate();
    }

    this.checkIsError();
  },
  methods: {
    filterInput(evt: any): void {
      if (!this.allowAllCharacters) {
        if (this.onlyNumbers === true) {
          if (!this.numbersFilter.test(evt.key) || evt.which === 42 || evt.which === 43) {
            evt.preventDefault();
          }
          return;
        }

        if (this.streetFilter === true) {
          if (!this.streetCharactersFilter.test(evt.key) || evt.which === 42 || evt.which === 43) {
            evt.preventDefault();
          }
          return;
        }

        if (!this.standardFilter === true) {
          if (!this.standardCharactersFilter.test(evt.key) || evt.which === 42 || evt.which === 43) {
            evt.preventDefault();
          }
          return;
        }
      }
    },
    loadData(): void {
      if (this.formDataStore.hasOwnProperty(this.name) && null !== this.formDataStore[this.name]) {
        this.isDataLoading = true;
        this.model = this.formDataStore[this.name];
      }
      this.$emit("dataPreloadComplete", this.model);
    },

    focusEvent() {
      this.$emit("keyup");
      this.$emit("focus");
    },

    checkIsError() {
      const checkError = setInterval(() => (this.error = this.$store.state.errors.get(this.name)), 50);

      if (this.error) {
        clearInterval(checkError);
      }
    },

    checkIsTaxOfficeField() {
      const searchedText = "PolandTaxOfficeId";
      return this.name.indexOf(searchedText) > -1 && this.model.length;
    },

    validate() {
      if (this.isValidated) {
        this.$store.dispatch("validate", {
          name: this.name,
          value: this.model,
        });
      }
      this.$emit("blur", this.model);
      this.validateCity = false;
      this.validateStreet = false;
      this.validateBuildingNumber = false;
      this.validateApartmentNumber = false;
    },

    pasteHandler(evt: ClipboardEvent) {
      if (!this.allowAllCharacters) {
        if (this.onlyNumbers === true) {
          //@ts-ignore
          if (!this.numbersFilter.test(evt.clipboardData.getData("text"))) {
            evt.preventDefault();
          }
        }

        if (!this.standardFilter === true) {
          //@ts-ignore
          if (!this.standardCharactersFilter.test(evt.clipboardData.getData("text"))) {
            evt.preventDefault();
          }
        }
      }
      if (this.disablePaste) {
        evt.preventDefault();
      }
    },
  },
  computed: {
    ...mapState({
      isValidFieldsChanged(): boolean {
        return this.$store.state.isValidFieldsChanged;
      },
      formDataStore(): any {
        return this.$store.state.formData;
      },
    }),
  },
  watch: {
    isValidFieldsChanged(): void {
      if (this.name == "postalCode") {
        this.model = (<HTMLInputElement>document.querySelector('input[name="postalCode"]')).value;
        this.$emit("input", this.model);
      }
      if (this.name == "city") {
        this.model = (<HTMLInputElement>document.querySelector('input[name="city"]')).value;
        this.$emit("input", this.model);
        if (this.model && this.validateCity) {
          this.validate();
        }
      }
      if (this.name == "street") {
        this.model = (<HTMLInputElement>document.querySelector('input[name="street"]')).value;
        this.$emit("input", this.model);
        if (this.model && this.validateStreet) {
          this.validate();
        }
      }
      if (this.name == "buildingNumber") {
        this.model = (<HTMLInputElement>document.querySelector('input[name="buildingNumber"]')).value;
        this.$emit("input", this.model);
        if (this.model && this.validateBuildingNumber) {
          this.validate();
        }
      }
      if (this.name == "apartmentNumber") {
        this.model = (<HTMLInputElement>document.querySelector('input[name="apartmentNumber"]')).value;
        this.$emit("input", this.model);
        if (this.model && this.validateApartmentNumber) {
          this.validate();
        }
      }
      this.isValid = this.$store.state.validFields.has(this.name);

      if (this.isValid) {
        this.$store.commit(DELETE_ERROR, this.name);
      }
    },
    value(): void {
      this.model = this.value;
    },
    model(): void {
      if (!this.isDataLoading) {
        this.$store.commit(DELETE_ERROR, this.name);
      } else {
        this.isDataLoading = false;
      }

      this.$emit("input", this.model);
    },
    error() {
      if (this.checkIsTaxOfficeField()) {
        this.isValid = true;
        this.error = null;
      }
    },
  },
  components: {
    Error,
  },
});
